/* eslint-disable max-params */
import { PROFILE_MESSAGES } from '../constants';
import {
  ContactDetail,
  DegreeData,
  ProfileCard,
  ProfileGroup,
} from '../types/contact.type';
export function getProfileCards(
  data: ContactDetail,
  specialty: string,
  phoneGroups: ProfileGroup[],
  addressGroups: ProfileGroup[],
  degreeGroups: ProfileGroup[],
  isInternal: boolean,
): ProfileCard[] {
  // Only include degrees and addresses if user is PI
  const _piField: ProfileGroup | null = data?.isPi
    ? {
        fields: [
          {
            id: crypto.randomUUID(),
            label: 'Primary Specialization',
            propKey: 'specialty',
            type: 'string',
            value: specialty,
          },
          {
            id: crypto.randomUUID(),
            label: 'NPI Number',
            propKey: 'npi',
            type: 'number',
            value: data?.npi ?? '',
          },
        ],
        icon: 'edit_outline',
        title: 'PI Information',
      }
    : null;

  const cards: ProfileCard[] = [
    {
      groups: [
        ...(isInternal
          ? [
              {
                fields: [
                  {
                    id: crypto.randomUUID(),
                    label: 'Organization Role',
                    value: data?.organizationRole?.name ?? '',
                  },
                ],
              },
            ]
          : []),
        ...(isInternal
          ? [
              {
                fields: [
                  {
                    id: crypto.randomUUID(),
                    label: 'Primary Contact ID',
                    propKey: 'legacyId',
                    type: 'number',
                    value: data.legacyId, 
                  },
                  {
                    hintText: 'Seperate multiple IDs with commas.',
                    id: crypto.randomUUID(),
                    label: 'Additional Contact IDs',
                    propKey: 'additionalLegacyIds',
                    type: 'string',
                    value: data.additionalLegacyIds,
                  },
                ],
                icon: 'edit_outline',
                title: 'Contact IDs',
              },
            ]
          : []),
        _piField,
        {
          fields: [
            ...(data?.isPi
              ? [
                  {
                    id: crypto.randomUUID(),
                    label: 'Country Location',
                    value: data?.piCountry,
                  },
                ]
              : []),
            {
              id: crypto.randomUUID(),
              label: 'Timezone',
              value: data?.timezone,
            },
          ],
        },
      ].filter((g): g is ProfileGroup => g !== null && !!g),
      heading: 'Profile Information',
      showAddButton: false,
      type: 'phones',
    },
  ];

  // Add Physical Addresses card only if user is PI
  if (data?.isPi) {
    cards.push({
      emptyMessage: PROFILE_MESSAGES.NO_ADDRESSES,
      groups: addressGroups,
      heading: 'Physical Addresses',
      propKey: 'mailingAddresses',
      showAddButton: true,
      type: 'mailingAddresses',
    });
  }

  // Always add Phone Numbers card
  cards.push({
    emptyMessage: PROFILE_MESSAGES.NO_PHONES,
    groups: phoneGroups,
    heading: 'Phone Numbers',
    propKey: 'phones',
    showAddButton: true,
    type: 'phones',
  });

  return cards;
}

export function createProfileGroups(
  items: unknown[],
  showMenu: boolean = false,
  options?: { showDelete?: boolean; showDrag?: boolean },
): ProfileGroup[] {
  if (!items) {
    return [];
  }
  return items.map(
    (item) =>
      ({
        fields: [{ id: crypto.randomUUID(), label: '', value: item }],
        showMenu,
        ...options,
      }) as ProfileGroup,
  );
}

export function constructDegrees(degress: string[]): DegreeData {
  return {
    degrees: degress,
    emptyMessage: PROFILE_MESSAGES.NO_DEGREES,
    heading: 'Degrees',
    propKey: 'degrees',
    showAddButton: true,
    showDelete: true,
    showDrag: true,
    type: 'degrees',
  };
}
